// All praise to http://stackoverflow.com/a/13322059 for inspiration
var ImageMap = function ($map, $img) {
            var n,
                $areas = $('area', $map),
                len = $areas.length,
                originalCoords = [],
                originalWidth = $img[0].naturalWidth,
                previousWidth = originalWidth;
            for (n = 0; n < len; n++) {
                originalCoords[n] = $areas[n].coords.split(',');
            }
            this.resize = function () {
                var newWidth = $img.width();
                // do recalculation only if window resize actually causes an image resize (because with bootstrap CSS, it usually doesn't)
                if (newWidth != previousWidth) {
                    var newCoords = [];
                    var n, m, clen;
                    var x = newWidth / originalWidth;
                    for (n = 0; n < len; n++) {
                        clen = originalCoords[n].length;
                        newCoords[n] = [];
                        for (m = 0; m < clen; m++) {
                            newCoords[n][m] = originalCoords[n][m] * x;
                        }
                        $areas[n].coords = newCoords[n].join(',');
                    }
                    previousWidth = newWidth;
                }
                return true;
            };
            $(window).on('resize', this.resize);
        };